<template>
  <el-card  id="confManageTemp">
    <div class="search-form">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="更新时间" prop="updateTimeStart">
          <el-date-picker type="date" v-model="originData.updateTimeStart" placeholder="起始日期"/>
          <span style="margin:auto 10px;color:#999999">至</span>
          <el-date-picker type="date" v-model="originData.updateTimeEnd" placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="参数名称" prop="paramName">
          <el-input placeholder="请输入参数名称" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.paramName"/>
        </el-form-item>
        <el-form-item label="参数标识" prop="paramIdentif">
          <el-input placeholder="请输入参数标识" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.paramIdentif"/>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType">
          <el-select v-model.trim="originData.moduleType">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
            <el-option label="全部" value="" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="search"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addDialogCtrl()'
          v-if="judgeJurisdiction('412819140371238912')"
        >新增参数</yh-button>
      </div>
    </div>
    <!--参数列表-->
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%">
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          v-for="item in tableColumnData"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span
              class="button--blue"
              @click="editDialogCtrl(scope.row)"
              type="primary"
              v-if="judgeJurisdiction('412818536668286976')"
            >修改</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!--分页-->
    <el-row style="text-align:center">
      <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
      />
    </el-row>
    <!--新增参数模态框-->
    <yh-dialog title="新增参数配置" :visible.sync="addDialogVisible">
      <el-form :model="addParamData" class="hide-error" label-width="110px">
        <el-form-item label="参数名称" prop="paramName" required>
          <el-input v-model="addParamData.paramName" placeholder="请输入参数名称，不超过20字" maxlength="20"/>
        </el-form-item>
        <el-form-item label="参数标识" prop="moduleIdentif" required>
          <el-input v-model="addParamData.paramIdentif" placeholder="请输入参数标识，不超过40字" maxlength="40"/>
        </el-form-item>
        <el-form-item label="参数值" prop="paramValue" required>
          <el-input v-model="addParamData.paramValue" @blur="addBlurCheck" placeholder="请输入参数值，不超过四位小数"  maxlength="25"/>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType" required>
          <el-select  v-model="addParamData.moduleType" placeholder="请选择归属模块" style="width:100%">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
          </el-select>
        </el-form-item>
        <el-form-item label="参数说明" prop="paramExplain" >
          <el-input type="textarea" v-model="addParamData.paramExplain"  :autosize="{ minRows: 5}" placeholder="请输入参数说明，不超过200字" maxlength="200"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="addParamDetail();">提交</el-button>
      </span>
    </yh-dialog>
    <!--修改参数模态框-->
    <yh-dialog title="修改参数配置" :visible.sync="editDialogVisible">
      <el-form :model="editParamData" class="hide-error" label-width="110px">
        <el-form-item label="参数名称" prop="paramName" required>
          <el-input v-model="editParamData.paramName" placeholder="请输入参数名称，不超过20字" maxlength="20"/>
        </el-form-item>
        <el-form-item label="参数标识" prop="moduleIdentif" required>
          <el-input v-model="editParamData.paramIdentif" placeholder="请输入参数标识，不超过40字" maxlength="40" disabled/>
        </el-form-item>
        <el-form-item label="参数值" prop="paramValue" required>
          <el-input v-model="editParamData.paramValue" @blur="uptBlurCheck" placeholder="请输入参数值，不超过四位小数" maxlength="25"/>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType" required>
          <el-select  v-model="editParamData.moduleType" placeholder="请选择归属模块" style="width:100%">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
          </el-select>
        </el-form-item>
        <el-form-item label="参数说明" prop="paramExplain" >
          <el-input type="textarea" v-model="editParamData.paramExplain"  :autosize="{ minRows: 5}" placeholder="请输入参数说明，不超过200字" maxlength="200"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="uptLoading" @click="editParamDetail();">提交</el-button>
      </span>
    </yh-dialog>
  </el-card>
</template>
<script>
import { getFunctionList, getPagingData } from '@/mixins';

export default {
  mixins: [getFunctionList, getPagingData],
  data() {
    return {
      functionList: [],
      emptyText: this.$LS.empty,
      errorCode: 'E00000',
      // 条件查询
      originData: {
        updateTimeStart: '',
        updateTimeEnd: '',
        paramName: '',
        paramIdentif: '',
        moduleType: '',
      },
      searchParam: {
        updateTimeStart: '',
        updateTimeEnd: '',
        paramName: '',
        paramIdentif: '',
        moduleType: '',
      },
      // 新增数据集
      addParamData: {
        paramIdentif: '',
        paramName: '',
        paramValue: '',
        paramExplain: '',
        moduleType: 'commonModule',
      },
      // 修改数据集
      editParamData: {
        id: '',
        paramIdentif: '',
        paramName: '',
        paramValue: '',
        paramExplain: '',
        moduleType: '',
      },
      // 列名
      tableColumnData: [
        {
          label: '参数ID',
          prop: 'id',
          width: 200,
        }, {
          label: '参数标识',
          prop: 'paramIdentif',
          width: 200,
        }, {
          label: '参数名称',
          prop: 'paramName',
          width: 200,
        }, {
          label: '参数值',
          prop: 'paramValue',
          width: 200,
        }, {
          label: '归属模块',
          prop: 'moduleName',
          width: 200,
        }, {
          label: '参数说明',
          prop: 'paramExplain',
          width: 200,
        }, {
          label: '更新时间',
          prop: 'updateTime',
          width: 200,
        }, {
          label: '更新人ID',
          prop: 'updateUser',
          width: 200,
        },
      ],
      // 参数列表
      tableData: [],
      moduleData: [],
      // 当前页码
      currentPage: 1,
      pageSize: 10,
      pageNo: 1,
      // 数据量
      sumCount: 0,
      // 新增模态框可见标记
      addDialogVisible: false,
      // 修改模态框可见标记
      editDialogVisible: false,
      addLoading: false,
      uptLoading: false,
    };
  },
  watch: {
    // 分页查询
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData(true);
        this.getModuleList();
      },
    },
    'addParamData.paramValue': function (value) {
      this.addParamData.paramValue = value.replace(/[^0-9\.]+/, '');
      if (this.addParamData.paramValue.indexOf('.') === 0) {
        this.addParamData.paramValue = '';
      }
      if (this.addParamData.paramValue.indexOf('.') !== -1) {
        const valuebefore = value.substring(0, value.indexOf('.'));
        const valueAfter = value.substring(value.indexOf('.') + 1, value.indexOf('.') + 5).replace(/\D+/, '');
        this.addParamData.paramValue = `${valuebefore}.${valueAfter}`;
      }
    },
    'editParamData.paramValue': function (value) {
      this.editParamData.paramValue = value.replace(/[^0-9\.]+/, '');
      if (this.editParamData.paramValue.indexOf('.') === 0) {
        this.editParamData.paramValue = '';
      }
      if (this.editParamData.paramValue.indexOf('.') !== -1) {
        const valuebefore = value.substring(0, value.indexOf('.'));
        const valueAfter = value.substring(value.indexOf('.') + 1, value.indexOf('.') + 5).replace(/\D+/, '');
        this.editParamData.paramValue = `${valuebefore}.${valueAfter}`;
      }
    },
  },
  mounted() {
    const token = this.$route.query.userToken;
    const sessionData = JSON.parse(this.$route.query.sessionData);
    sessionStorage.setItem('userToken', JSON.stringify(token));
    sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    this.getJurisdiction();
  },
  methods: {
    // 获取功能权限
    getJurisdiction() {
      const params = {
        data: {
          roleId: JSON.parse(sessionStorage.getItem('sessionData')).roleId,
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          token: JSON.parse(sessionStorage.getItem('userToken')),
        },
      };
      this.$_post(this.$API.get_role_menu, params).then((res) => {
        console.log(res);
        this.functionList = res.data.roleMenuList;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 判断是否有权限
    judgeJurisdiction(v) {
      for (let index = 0; index < this.functionList.length; index++) {
        if (this.functionList[index].menuId === v) {
          return true;
        }
      }
      return false;
    },
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    // 参数查询
    getTableData(emptyValue) {
      this.getPagingData(this.$API.getParamList, emptyValue);
    },
    reset() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 模块查询
    getModuleList() {
      const params = {};
      this.$_post(this.$API.getModuleList, params).then((res) => {
        this.moduleData = res.data.list;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 新增参数
    addParamDetail() {
      if (this.addParamData.paramName === '') {
        this.$message({
          message: '请输入参数名称',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      if (this.addParamData.paramIdentif === '') {
        this.$message({
          message: '请输入参数标识',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      if (this.addParamData.paramValue === '') {
        this.$message({
          message: '请输入参数值',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      if (this.addParamData.moduleType === '') {
        this.$message({
          message: '请选择归属模块',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      this.addLoading = true;
      this.$_yh_confirm('参数新增后将无法删除，确定要新增吗？', '新增参数').then(() => {
        const params = {
          data: {
            paramName: this.addParamData.paramName,
            paramIdentif: this.addParamData.paramIdentif,
            paramValue: this.addParamData.paramValue,
            moduleType: this.addParamData.moduleType,
            paramExplain: this.addParamData.paramExplain,
            updateUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            createUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.addParamDetail, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.addDialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.addLoading = false;
      }).catch(() => {
        this.addLoading = false;
      });
    },
    // 编辑参数
    editParamDetail(id) {
      if (this.editParamData.paramName === '') {
        this.$message({
          message: '请输入参数名称',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      if (this.editParamData.paramValue === '') {
        this.$message({
          message: '请输入参数值',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      if (this.editParamData.moduleType === '') {
        this.$message({
          message: '请选择归属模块',
          type: 'warning',
          showClose: true,
        });
        return false;
      }
      this.uptLoading = true;
      this.$_yh_confirm(`确认要修改"${this.editParamData.paramIdentif}"的参数信息吗？`, '修改参数').then(() => {
        const params = {
          data: {
            id: this.editParamData.id,
            paramName: this.editParamData.paramName,
            paramValue: this.editParamData.paramValue,
            moduleType: this.editParamData.moduleType,
            paramExplain: this.editParamData.paramExplain,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.editParamDetail, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.editDialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.uptLoading = false;
      }).catch(() => {
        this.uptLoading = false;
      });
    },
    // 新增模态框控制器
    addDialogCtrl() {
      // 清理历史新增数据
      this.addParamData.paramIdentif = '';
      this.addParamData.paramName = '';
      this.addParamData.paramValue = '';
      this.addParamData.paramExplain = '';
      this.addParamData.moduleType = 'commonModule';
      // 打开新增模态框
      this.addDialogVisible = true;
    },
    // 编辑模态框控制器
    editDialogCtrl(params) {
      this.editParamData.id = params.id;
      this.editParamData.paramIdentif = params.paramIdentif;
      this.editParamData.paramName = params.paramName;
      this.editParamData.paramValue = params.paramValue;
      this.editParamData.paramExplain = params.paramExplain;
      this.editParamData.moduleType = params.moduleType;
      // 打开编辑模态框
      this.editDialogVisible = true;
    },
    closeEditDialog() {
      this.editParamData.id = '';
      this.editParamData.paramIdentif = '';
      this.editParamData.paramName = '';
      this.editParamData.paramValue = '';
      this.editParamData.paramExplain = '';
      this.editParamData.moduleType = '';
      this.editDialogVisible = false;
    },
    addBlurCheck() {
      const tmpValue = this.addParamData.paramValue;
      const lastBit = tmpValue.substring(tmpValue.length - 1, tmpValue.length);
      if (lastBit === '.') {
        this.addParamData.paramValue = tmpValue.replace('.', '');
      }
    },
    uptBlurCheck() {
      const tmpValue = this.editParamData.paramValue;
      const lastBit = tmpValue.substring(tmpValue.length - 1, tmpValue.length);
      if (lastBit === '.') {
        this.editParamData.paramValue = tmpValue.replace('.', '');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#confManageTemp {
  overflow: initial;
  .search-col {
    display: flex;
  }
  .search-col-div {
    display: table;
    line-height: 27px;
  }
  .editKey {
    line-height: 30px;
    text-align: right;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
  }
}
</style>
